module.exports = __webpack_public_path__ + "img/571-42dfb3.png";